import { AppModule } from 'app/module';
import { Input } from 'module/input/main';
import { Autocomplete } from 'module/autocomplete/main';
import { serializeJson } from 'util/form';
import { API_ENDPOINT_AUTOCOMPLETE_COMPANY_KEYWORDS, API_ENDPOINT_AUTOCOMPLETE_LOCATIONS } from 'app/endpoints';
import 'module/button/main';
import { getParams } from 'util/url';
import { trackGa4 } from 'util/googleAnalytics';
import Template from './template.hbs';
import './styles.scss';

export class CompaniesSearchform extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            keywords: '.m-companiesSearchform__keywords .m-input',
            keywordsAutocomplete: '.m-companiesSearchform__keywordsAutocomplete .m-autocomplete',
            locations: '.m-companiesSearchform__locations .m-input',
            locationsAutocomplete: '.m-companiesSearchform__locationsAutocomplete .m-autocomplete',
        };
    }

    getPropsFromDom() {
        return serializeJson(this.dom.el);
    }

    domEvents() {
        this.dom.el.addEventListener('submit', (e) => this.submitForm(e));
    }

    ready() {
        const { benefits } = getParams(window.location.search);

        if (benefits) {
            trackGa4({
                keywords: null,
                locations: null,
                event: 'search',
                form_type: 'Company Search',
                filters: 'benefits',
                benefits: benefits.toString() ?? null,
            });
        }
    }

    submitForm(e) {
        if (e) e.preventDefault();

        const hasActiveAutocomplete = this.hasActiveAutocomplete();

        this.keywordsAutocomplete.insertSelectedItem();
        this.locationsAutocomplete.insertSelectedItem();

        if (!hasActiveAutocomplete) {
            const newProps = Object.assign(
                serializeJson(this.dom.el),
                // always send empty slugs from search form
                {
                    locationSlug: false,
                },
            );

            this.setProps(newProps, false);
            this.events.emit('submit', newProps);
        }
    }

    hasActiveAutocomplete() {
        const keywordsAutocompleteProps = this.keywordsAutocomplete.getProps();
        const locationsAutocompleteProps = this.locationsAutocomplete.getProps();

        if ((keywordsAutocompleteProps && keywordsAutocompleteProps.selectedIndex)
            || (locationsAutocompleteProps && locationsAutocompleteProps.selectedIndex)) {
            return true;
        }
        return false;
    }

    subs() {
        this.keywords = new Input(this.dom.keywords);
        this.keywordsAutocomplete = new Autocomplete(this.dom.keywordsAutocomplete);
        this.keywordsAutocomplete.set({
            input: this.keywords,
            endpoint: API_ENDPOINT_AUTOCOMPLETE_COMPANY_KEYWORDS,
        });

        this.locations = new Input(this.dom.locations);
        this.locationsAutocomplete = new Autocomplete(this.dom.locationsAutocomplete);
        this.locationsAutocomplete.set({
            input: this.locations,
            endpoint: API_ENDPOINT_AUTOCOMPLETE_LOCATIONS,
        });
    }

    resetInputValues() {
        this.locations.setValue('');
        this.keywords.setValue('');
    }
}
